export const MERCHANT_CONSTANTS = {
  SEM_BUSINESS_NAME_LIMIT: 30
};



// WEBPACK FOOTER //
// ./src/app/merchants/merchant.constants.ts